import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-widget-spinner',
  imports: [CommonModule, MatProgressSpinnerModule, TranslateModule],
  templateUrl: './widget-spinner.component.html',
  styleUrls: ['./widget-spinner.component.scss'],
})
export class WidgetSpinnerComponent {
  @Input() loading = false;
  @Input() loadingHintTranslationKey!: string;
}
